
export default function AboutSection() {
  return (
    <section id="about" className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            番組について
          </h3>
          <div className="w-24 h-1 bg-[#ff1493] mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-[#ff1493]/20 rounded-3xl blur-3xl"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/85886d1417de6fbe41ef451689f4825b.jpg"
              alt="Radio Equipment"
              className="relative w-full h-full object-cover rounded-3xl shadow-2xl"
            />
          </div>

          <div className="space-y-6">
            <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#ff1493] rounded-full flex-shrink-0">
                  <i className="ri-mic-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white mb-3">番組コンセプト</h4>
                  <p className="text-white/80 leading-relaxed text-base">
                    「Windie's Mania SHABADABA」は、メジャーではないけれど魅力的なインディーズカルチャーを紹介するラジオ番組です。小劇団の公演情報、インディーズ歌手の新曲、自主制作映画など、マイナーだからこそ輝くコンテンツをお届けします。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#ffd700] rounded-full flex-shrink-0">
                  <i className="ri-heart-line text-2xl text-[#0a1628]"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-white mb-3">こんな方におすすめ</h4>
                  <ul className="space-y-2 text-white/80 text-base">
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-[#ff1493]"></i>
                      インディーズ音楽が好きな方
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-[#ff1493]"></i>
                      小劇場演劇に興味がある方
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-[#ff1493]"></i>
                      自主制作映画を応援したい方
                    </li>
                    <li className="flex items-center gap-2">
                      <i className="ri-check-line text-[#ff1493]"></i>
                      新しい才能を発掘したい方
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#ff1493]/10 backdrop-blur-sm p-6 rounded-xl border border-[#ff1493]/30 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-[#ff1493] rounded-full mx-auto mb-3">
                  <i className="ri-calendar-line text-xl text-white"></i>
                </div>
                <p className="text-white/70 text-sm mb-1 whitespace-nowrap">放送日時</p>
                <p className="text-white font-bold text-base whitespace-nowrap">毎週火曜</p>
                <p className="text-[#ff1493] font-bold text-lg whitespace-nowrap">18:30〜</p>
              </div>
              <div className="bg-[#ffd700]/10 backdrop-blur-sm p-6 rounded-xl border border-[#ffd700]/30 text-center">
                <div className="w-10 h-10 flex items-center justify-center bg-[#ffd700] rounded-full mx-auto mb-3">
                  <i className="ri-radio-2-line text-xl text-[#0a1628]"></i>
                </div>
                <p className="text-white/70 text-sm mb-1 whitespace-nowrap">放送局</p>
                <p className="text-white font-bold text-base whitespace-nowrap">コミュニティFM</p>
                <p className="text-[#ffd700] font-bold text-lg whitespace-nowrap">83.6MHz</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
